module.exports = __webpack_public_path__ + "static/media/gravite-etiquettes-transport.5163f718.png";